import { h, Fragment } from '@stencil/core';
import { EQdsButtonImportance, EQdsButtonSize, } from '@pes-ui/utils';
export class EnvironmentalDetail {
  constructor() {
    this.title = undefined;
    this.logo = undefined;
    this.description = undefined;
    this.links = undefined;
    this.isMobile = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a;
    return (h(Fragment, null, h("div", { class: "envdetail__section" }, !this.isMobile && h("pes-logo", { logo: this.logo, title: this.title }), this.description && (h("div", { class: "envdata__description", innerHTML: this.description })), (_a = this.links) === null || _a === void 0 ? void 0 :
      _a.map((link) => {
        const { title, url } = link;
        return (h("div", { class: "environmental__link" }, h("qds-standalone-link", { importance: EQdsButtonImportance.EMPHASIZED, size: EQdsButtonSize.SMALL, href: url, target: "_blank", dir: this.el.dir }, title)));
      }))));
  }
  static get is() { return "pes-environmental-detail"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["environmental-detail.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["environmental-detail.css"]
    };
  }
  static get properties() {
    return {
      "title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "title",
        "reflect": false
      },
      "logo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TEnvironmentalLogo",
          "resolved": "{ url?: string; absoluteUrl?: string; alt?: string; }",
          "references": {
            "TEnvironmentalLogo": {
              "location": "import",
              "path": "../environmental-data/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "description",
        "reflect": false
      },
      "links": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TEnvironmentalDataLink[]",
          "resolved": "TEnvironmentalDataLink[]",
          "references": {
            "TEnvironmentalDataLink": {
              "location": "import",
              "path": "../environmental-data/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
